/**
 * RBAC read-failure classification (2026-07-19, QA-account team-page incident).
 *
 * useRbac's candidate walk treats a thrown Firestore read as "we could not
 * determine access" and surfaces the retryable "couldn't load team settings —
 * usually temporary" wall. That is only honest for failures that can succeed
 * on retry. A `permission-denied` is DETERMINISTIC — rules evaluate identically
 * every time — and one candidate probe is denied BY DESIGN for nearly every
 * caller: the top-level accounts/{id} owner-field read is only permitted for
 * the caller's own email-hash mapping doc, so probing a real accountId always
 * throws permission-denied. Counting that as retryable put every user with a
 * missing members doc into an infinite "usually temporary" retry loop (seen on
 * the migrated QA account) instead of the honest access-restricted wall.
 *
 * So: `permission-denied` ⇒ treat the candidate as not-found (rules are the
 * authority on access; retry cannot change the outcome). Everything else —
 * unavailable, deadline-exceeded, a browser extension killing the Listen
 * channel, offline — stays retryable.
 */
export function isRetryableRbacReadError(err: unknown): boolean {
  const code = String((err as { code?: unknown })?.code ?? '');
  return code !== 'permission-denied';
}
